import { ITab } from 'api-paths-cas';

export enum UserRole {
  Admin = '[Admin]',
  UniAdmin = '[UniAdmin]',
  Uni = '[Uni]',
  UniSecure = '[UniSecure]',
  UniLite = '[UniLite]',
  Agent = '[Agent]',
  Enroly = '[Enroly]',
  AgencyAdmin = '[AgencyAdmin]',
  Partner = '[Partner]',
  ImmigrationProvider = '[ImmigrationProvider]',
  Unknown = '[Unknown]',
}

export const makeTabs = (
  totals: Array<any>,
  configTabs: Array<ITab>,
  userRole: UserRole,
  pathwayAccess: 'Full' | 'Partial' | 'None',
  isPathway: boolean,
  activeTab?: string,
) => {
  if (!configTabs) return [];
  if (
    [UserRole.UniAdmin, UserRole.Uni, UserRole.UniSecure, UserRole.UniLite].includes(userRole) &&
    pathwayAccess === 'None' &&
    !isPathway
  ) {
    configTabs = configTabs.filter(tab => tab.id !== 'Pathway Review');
  }
  const tabs = configTabs.map(tab => {
    return {
      id: tab.id,
      label: tab.label,
      statuses: tab.statuses,
      count: totals.find((doc: any) => doc.casStatus === tab.id)?.total ?? 0,
      active: activeTab === tab.id,
      color: tab.color,
      isVisaStatusVisible: tab.isVisaStatusVisible,
      isArrStatusVisible: tab.isArrStatusVisible,
      isAccStatusVisible: tab.isAccStatusVisible,
      isConditionalStatusVisible: tab.isConditionalStatusVisible,
      isFollowUpDocsCountVisible: tab.isFollowUpDocsCountVisible,
      isFundsMatVisible: tab.isFundsMatVisible,
      isDocsCountVisible: tab.isDocsCountVisible,
      isDepositDateVisible: tab.isDepositDateVisible,
      isAgentDocsCountVisible: tab.isAgentDocsCountVisible,
      isRecordedInterviewVisible: tab.isRecordedInterviewVisible,
      isInterviewVisible: tab.isInterviewVisible,
      isNotInvited: tab.isNotInvited,
      isDaysInStageVisible: true, // non configurable field should e visible for all stages
    };
  });

  return tabs;
};
